import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { EnterEmailPage } from '@/app/Auth/pages/EnterEmailPage';
import type { PageStaticData } from '@/shared/routing';
import { browserLanguageLoaded } from '@/shared/utils/internationalisation';

export const Route = createFileRoute('/auth/enter-email')({
    staticData: { access: 'public', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ redirectTo: 'optional' }),
    loader: () => browserLanguageLoaded(),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const redirectTo = Route.useSearch({ select: (search) => search.redirectTo });
    return <EnterEmailPage redirectTo={redirectTo} />;
}
